import React from "react"

export default () => (
    <div className="circleF">
        <svg xmlns="http://www.w3.org/2000/svg" width="365" height="519"><path class="circleFsvg" d="M95,259.5c0-83.7,39.623-158.139,101.515-205.883A259.827,259.827,0,0,1,460,22.343V496.657A258.64,258.64,0,0,1,354.5,519C211.182,519,95,402.818,95,259.5Z" transform="translate(-95)"/></svg>
    </div>
)